import { Subscription, SubscriptionPlan, SubscriptionStatus } from '../../domain/models';

export interface SubscriptionEntity {
  id: string;
  user_id: string;
  plan: string;
  status: string;
  platform?: string;
  revenuecat_id?: string;
  current_period_start?: string;
  current_period_end?: string;
  created_at?: string;
  updated_at?: string;
}

export const subscriptionEntityToModel = (entity: SubscriptionEntity): Subscription => {
  return {
    id: entity.id,
    userId: entity.user_id,
    plan: entity.plan as SubscriptionPlan,
    status: entity.status as SubscriptionStatus,
    platform: entity.platform,
    revenuecatId: entity.revenuecat_id,
    currentPeriodStart: entity.current_period_start ? new Date(entity.current_period_start) : undefined,
    currentPeriodEnd: entity.current_period_end ? new Date(entity.current_period_end) : undefined,
  };
};
